/** @format */
import { validate as uuidValidate, version as uuidVersion } from 'uuid';

export const isUuidCheckoutId = (checkoutId: string): boolean =>
    uuidValidate(checkoutId) && uuidVersion(checkoutId) === 4;
